import get from 'lodash/get';
import { QUESTION_TYPES } from '../../constants/props';

export default question =>
  get(question, 'settings.name') === QUESTION_TYPES.comment;



// WEBPACK FOOTER //
// ./src/utils/survey/checkComment.js